module.exports = "/_next/static/images/regular-updated-mobile-282cf9b3bc3dc96b8ae4676a4c8bee4a.svg";